/* 金额格式化过滤器 */

export default function jeFormat(value) {
	let str = value;
	let returnStr;
	if (typeof str !== 'string') {
		str = String(str);
	}
	const regex = /\B(?=(\d{3})+(?!\d))/g;
	if (str.indexOf('.') == -1) {
		returnStr = `${str.replace(regex, ',')}.00`;
	} else {
		const newStr = str.split('.');
		returnStr = newStr[0].replace(regex, ',');

		if (newStr[1].length <= 1) {
			// 小数点后只有一位时
			returnStr = `${returnStr}.${newStr[1]}0`;
		} else if (newStr[1].length > 1) {
			// 小数点后两位以上时
			const decimals = newStr[1].substr(0, 2);
			returnStr = `${returnStr}.${decimals}`;
		}
	}
	return returnStr;
	// if(value===null || value===undefined || value===''){
	//
	// }
	// else{
	//   return ''
	// }
}
